import { toDataSourceRequestString } from "@progress/kendo-data-query";
import { createApi } from "@reduxjs/toolkit/query/react";
import type {
    ListAdminChatConversationMessagesRequest,
    ListAdminChatConversationMessagesResponse,
    ListAdminChatConversationsRequest,
    ListAdminChatConversationsResponse
} from "../../contracts";
import { baseQueryAdminWithAuth } from "../api";

export const adminChatConversationApi = createApi({
    reducerPath: "adminChatConversationApi",
    baseQuery: baseQueryAdminWithAuth,
    endpoints: builder => ({
        listAdminChatConversations: builder.query<ListAdminChatConversationsResponse, ListAdminChatConversationsRequest>({
            query: body => ({
                url: `chatconversation/list?${toDataSourceRequestString(body)}`,
                method: "POST",
                body
            })
        }),
        listAdminChatConversationMessages: builder.query<ListAdminChatConversationMessagesResponse, ListAdminChatConversationMessagesRequest>({
            query: body => ({
                url: `chatconversation/messages/list?${toDataSourceRequestString(body)}`,
                method: "POST",
                body: body
            })
        })
    })
});

export const {
    useListAdminChatConversationsQuery,
    useListAdminChatConversationMessagesQuery
} = adminChatConversationApi;
